import { animate, state, style, transition, trigger } from '@angular/animations'
import { CommonModule, DatePipe, NgIf } from '@angular/common'
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewRef,
} from '@angular/core'
import { FormsModule, UntypedFormGroup } from '@angular/forms'
import { Router, RouterLinkActive } from '@angular/router'
import { NgIcon, provideIcons } from '@ng-icons/core'
import { heroArchiveBox, heroBookmark, heroEye, heroFolder, heroMagnifyingGlass, heroPencil } from '@ng-icons/heroicons/outline'
import { heroBookmarkSolid } from '@ng-icons/heroicons/solid'
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { DialogActionsComponent, DialogService, DialogTitleBarComponent, KENDO_DIALOGS, WindowCloseResult, WindowRef, WindowService } from '@progress/kendo-angular-dialog'
import { DropDownListComponent, KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import { CellTemplateDirective, ColumnComponent, DataBindingDirective, GridComponent, KENDO_GRID, KENDO_GRID_EXCEL_EXPORT, KENDO_GRID_PDF_EXPORT, PagerSettings, RowArgs, SelectionDirective } from '@progress/kendo-angular-grid'
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators'
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs'
import { SortDescriptor, State, filterBy } from '@progress/kendo-data-query'
import * as CryptoJS from 'crypto-js'
import { ToastrService } from 'ngx-toastr'
import { Subscription } from 'rxjs'
import { first } from 'rxjs/operators'
import { environment } from '../../../environments/environment'
import { UserStore } from '../../@core/stores/user.store'
import { InitUserService } from '../../@theme/services/init-user.service'
import { TransactionsServices } from '../../@theme/services/transactions.service'
import { MiddlemanService } from '../../auth/services/Middleman.service'
import { Utilities } from '../../utilities/utilities'
import { ClientinfoComponent } from '../ClientInfo/clientinfo.component'
import { FilemanagerComponent } from '../FileManager/filemanager.component'
// import { JwtHelperService } from '@auth0/angular-jwt'
interface Item {
  text: string
  value: number
}
@Component({
  selector: 'gd-bookmarktransaction',
  templateUrl: './bookmarktransaction.component.html',
  styleUrls: ['./bookmarktransaction.component.css'],
  animations: [
    trigger('simpleFadeAnimation', [
      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),
      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [style({ opacity: 0 }), animate(600)]),
      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave', animate(600, style({ opacity: 0 }))),
    ]),
  ],
  imports: [
    CommonModule,
    NgIf,
    GridComponent,
    SelectionDirective,
    DataBindingDirective,
    ColumnComponent,
    CellTemplateDirective,
    RouterLinkActive,
    DropDownListComponent,
    FormsModule,
/*     NgClass, */
    DialogTitleBarComponent,
    DialogActionsComponent,
    DatePipe,
    KENDO_DROPDOWNS,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_GRID_PDF_EXPORT,
    KENDO_GRID_EXCEL_EXPORT,
    KENDO_INDICATORS,
    KENDO_DIALOGS,
    KENDO_BUTTONS,
    NgIcon
  ],
  providers: [provideIcons({ heroEye, heroMagnifyingGlass, heroArchiveBox, heroPencil, heroFolder, heroBookmark, heroBookmarkSolid })]
})
export class BookmarktransactionComponent
  implements OnInit, AfterViewInit, OnDestroy {
  private getFilterdata = sessionStorage.getItem('blotterIdFiltered')
  public toggleText = 'Show'
  public RepNamInfo: any = []
  public autoPrint = true
  myValueSub: Subscription
  public type = 'numeric'
  public pendingSpinner = true
  private hitonce: number
  public buttonCount = 10
  public info = true
  public pageSizes = true
  public previousNext = true
  public show = false
  public skip = 0
  public enabled = true
  public pageSize = 5
  public duration = 1200
  public ShowReviewTransaction: boolean
  public direction = 'down'
  public SuperFlag: boolean
  public hidebyRole: boolean
  public get animate(): any {
    if (this.enabled) {
      return {
        type: this.type,
        direction: this.direction,
        duration: this.duration,
      }
    }

    return false
  }

  public mySelection: any[] = []
  @ViewChild(GridComponent, { static: true })
  public dropdownStatusLight: Array<Item> = []
  private subscription: Subscription
  public grid: GridComponent
  public multiple = false
  public allowUnsort = true
  public formGroup: UntypedFormGroup
  private viewlist: string
  public colorred: string
  private username: string
  private splitvalue: any
  public view: Array<any> = []
  public reload: any[]
  private roleing: any
  private repIdsession: number
  private listItems: any[] = []
  public clientId: string
  public clientName: string
  public blotterId: string
  public blotterComment: number
  public blotId: number
  public repId: string
  public selectedValue: any
  public opened: boolean
  public windowRef: WindowRef = null
  public openup: boolean
  private myblot: boolean
  public firstn: string
  public lastn: string
  public viewButtons = false
  public outquerystring: string
  public enlarge: string
  public default: string
  public roletransition: string
  public openAccountReadOnly: boolean
  public viewallblot: string
  public ReviewTransaction: boolean
  public gridState: State = {
    sort: [
      {
        field: 'dateReceived',
        dir: 'desc',
      },
    ],
    skip: 0,
    take: 18,
  }
  public sort: SortDescriptor[] = [
    {
      field: 'dateReceived',
      dir: 'desc',
    },
  ]
  public group: any[] = []
  public asPageable = (value) => Utilities.asType<PagerSettings>(value)
  constructor(
    private cdRef: ChangeDetectorRef,
    private _nextclear: MiddlemanService,
    private router: Router,
    private ngZone: NgZone,
    private toastrService: ToastrService,
    private ur: TransactionsServices,
    private getstring: InitUserService,
    private getrolestring: UserStore,
    private dialogService: DialogService,
    private windowService: WindowService,
  ) {
    this.opened = false
    this.SuperFlag = false
    this.viewallblot = ''
    this.viewButtons = false
    this.hidebyRole = false
    this.GetPendingTransaction()
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort

    this.dropdownStatusLight = [
      { text: 'Rep Processing Paperwork', value: -2 },
      /*       { text: "Branch Manager Review", value: -1 }, */
      { text: 'Processing Paperwork ', value: 0 },
      { text: 'Submitted for Review', value: 1 },
    ]
  }
  public get hasDirection(): boolean {
    return this.type === 'slide' || this.type === 'expand'
  }
  public ngAfterViewInit(): void {
    this.sortChange(this.sort)
    if (this.roleing !== 'REP' || this.roleing !== 'REPDATA') {
      this.SuperFlag = false
    } else {
      this.SuperFlag = true
    }
    this.cdRef.detectChanges()
    return
  }
  public onDataStateChange(): void {
    this.fitColumns()
  }

  ngOnInit() {
    this.subscription = this._nextclear.notifyredirectObservable$.subscribe(
      (res) => {
        if (res !== null) {
          if (this.roleing !== 'REP' || this.roleing !== 'REPDATA') {
            this.SuperFlag = false
          } else {
            this.SuperFlag = true
          }
        }
      },
    )
    if (this.roleing === undefined) {
      sessionStorage.getItem('rvarietylist')
      this.roleing = sessionStorage.getItem('rl')
    }
    sessionStorage.removeItem('rl')
    this.view = []
    this.colorred = 'No'
    this.openAccountReadOnly = false
    if (this.roleing === 'HOME OFFICE USER') {
      this.hidebyRole = true
    }
    if (this.roleing !== 'HOME OFFICE USER') {
      this.viewButtons = true
    }
    if (this.roleing === 'REP') {
      this.viewButtons = false
    }
    if (this.roleing === 'BRANCH MANAGER') {
      this.viewButtons = false
    }
    if (this.roleing === 'ADMIN') {
      this.viewButtons = true
    }
    if (this.roleing === 'BRANCH MANAGER') {
      this.viewButtons = false
    }
    if (this.roleing === 'BRANCH ACCESS NON MANAGER') {
      this.viewButtons = false
      //  this.hidebyRole = true
    }
    this.subscription = this._nextclear.notifyObservable$.subscribe((res) => {
      this.splitvalue = res.split('|')
      this.roleing = this.splitvalue[0]
      const paramT = CryptoJS.AES.encrypt(
        encodeURI(this.roleing).trim(),
        environment.securepw.trim(),
      ).toString()
      localStorage.setItem('rvarietylist', paramT)
      const storageValueReturn =
        localStorage.getItem('rvarietylist') == undefined
          ? ''
          : localStorage.getItem('rvarietylist')
      const rparam = CryptoJS.AES.decrypt(
        storageValueReturn,
        environment.securepw,
      ).toString(CryptoJS.enc.Utf8)
      this.roletransition = rparam
      if (
        this.roleing.toLocaleLowerCase() !== 'Rep'.toLocaleLowerCase() ||
        this.roleing.toLocaleLowerCase() !== 'RepData'.toLocaleLowerCase()
      ) {
        this.SuperFlag = false
      } else {
        this.SuperFlag = true
      }
    })

    const storageValueReturn =
      localStorage.getItem('rvarietylist') == undefined
        ? ''
        : localStorage.getItem('rvarietylist')
    const rparam = CryptoJS.AES.decrypt(
      storageValueReturn,
      environment.securepw,
    ).toString(CryptoJS.enc.Utf8)
    this.roletransition = rparam
    this.roleing = decodeURI(rparam)
  }

  viewClientInfo(clientId: number) {
    const clientInfoDialogRef = this.dialogService.open({
      title: 'View Client',
      content: ClientinfoComponent,
      maxHeight: '95%',
      width: '850px',
      maxWidth: '95%',
      actions: [{ text: 'Close', themeColor: 'primary' }],
    })

    const clientInfo = clientInfoDialogRef.content.instance
    clientInfo.clientId = clientId
  }

  /*
  ***********
  Progress kendo Grid
  Add on List to grid
  There is a update function based off selection.
  @Param statusTypeId
  ***********
  */
  public category(statusTypeId: number) {
    if (statusTypeId) {
      return this.dropdownStatusLight.find((x) => x.value === statusTypeId)
    } else
    {return null}
  }
  public isRowSelected(row: RowArgs) {
    return row.index % 2 === 0
  }
  handleOrderChange(selected: any, blotterId: number) {
    const param = { statusTypeId: selected, blotterstringId: blotterId }
    this.initiateupdateStatus(param)
  }
  initiateupdateStatus(param): void {
    this.ur.UpdatependingStats(param).subscribe((response) => {
      const datareturn = JSON.stringify(response)
      if (datareturn !== 'null') {
        this.toastrService.warning(datareturn['warning'], 'Alert')
      } else {
        const duration = 500
        this.showToastpst('success', 'Status')
        this.GetPendingTransaction()
      }
    })
  }

  /*
  ***********
  Progress kendo Grid Get Pending Transaction by Roles
  @Param RoleName
  ***********
  */
  GetPendingTransaction() {
    /*     const param = {
      RoleName: this.roleing,
      RepId: this.repIdsession,
      bookemarked: true,
    } */
    this.Startpendingretrievedata()
  }
  ngOnDestroy() {
    this.myValueSub.unsubscribe()
    this.subscription.unsubscribe()
  }
  Startpendingretrievedata() {
    this.myValueSub = this.ur
      .getbookmarks()
      .pipe(first())
      .subscribe((response) => {
        this.pendingSpinner = false
        this.listItems = response
        this.reload = response
        this.view = response
        const result = this.view
          .filter((res) => res.alertRep)
          .map((ele) => ele.blotterId)
        this.mySelection = result
        this.ShowReviewTransaction = this.view['ShowReviewTransaction']

        /* if (
          typeof this.getFilterdata !== null &&
          this.getFilterdata !== null &&
          Number(this.getFilterdata) !== 0
        ) {
          const myobjects = this.listItems.filter(
            (b) => b.blotterId == Number(this.getFilterdata),
          )
          //   this.view = this.listItems
          sessionStorage.removeItem('blotterIdFiltered')
        } */
        this.isRowSelected = (e: RowArgs) =>
          this.mySelection.indexOf(e.dataItem.blotterId) >= 0
        this.dropdownStatusLight = [
          { text: 'Rep Processing Paperwork', value: -2 },
          { text: 'Processing Paperwork ', value: 0 },
          /*  { text: 'Submitted for Review', value: 1 }, */
        ]
      })
    if (
      this.cdRef !== null &&
      this.cdRef !== undefined &&
      !(this.cdRef as ViewRef).destroyed
    ) {
      //   this.cdRef.detectChanges()
    }
    //  this.ngxLoader.stop()
  }
  /*
  ***********
  Progress kendo Grid Auto fix columns. Not using
  ***********
  */
  private fitColumns(): void {
    /*  this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
      //  this.grid.autoFitColumns();
    }); */
  }
  isBigEnough(element) {
    return element.alertRep === true
  }
  /*
  ***********
  Progress kendo Grid Post Request get Pending Transactions
  ***********
  */
  GetPendingTransactionFirstLoad() {
    //  this.ngxLoader.start()
    this.getstring.currentRole.subscribe((r) => {
      const getrolesplit = r.split('|')
      this.roleing = getrolesplit[0]
    })
    if (this.roleing === 'HOME OFFICE USER') {
      this.hidebyRole = true
      this.viewButtons = false
    }
    if (this.roleing === 'BRANCH ACCESS NON MANAGER') {
      this.hidebyRole = true
      this.viewButtons = false
    }
    if (this.roleing === 'REP') {
      this.viewButtons = false
    }
    if (this.roleing === 'HOME OFFICE USER') {
      this.hidebyRole = true
    }
    if (this.roleing === 'BRANCH MANAGER') {
      this.viewButtons = false
    }
    if (this.roleing === 'ADMIN') {
      this.viewButtons = true
    }
    if (this.roleing === 'COMPLIANCE') {
      this.viewButtons = true
    }
    //  this.ngxLoader.stop()
  }
  /*
  ***********
  Progress kendo Grid Filter by Branch
  ***********
  */
  onKeyUp(value) {
    if (value === 'Filter By Branch') {
      this.view = this.reload
      return
    }
    this.view = filterBy(this.listItems, {
      logic: 'or',
      filters: [
        {
          field: 'branchNumber',
          operator: 'contains',
          value: value,
        },
        {
          field: 'repName',
          operator: 'contains',
          value: value,
        },
      ],
    })
    sessionStorage.removeItem('blotterIdFiltered')
    return
  }
  /*
  ***********
  Progress kendo Grid Filter by Rep
  ***********
  */
  onKeyUpRep(value: string) {
    if (value === 'Filter By Rep') {
      this.view = this.reload
      return
    }
    this.view = filterBy(this.listItems, {
      logic: 'or',
      filters: [
        {
          field: 'repName',
          operator: 'contains',
          value: value,
        },
      ],
    })
    sessionStorage.removeItem('blotterIdFiltered')
    return
  }
  /*
  ***********
  Based off User View
  ***********
  */
  onTradingView(v: any) {
    if (v === 'basic') {
      this.view = this.reload
      return
    }
    const myobjects = this.listItems.filter(
      (b) =>
        b.statusTypeId == 0 &&
        (b.productTypeId == 1 ||
          b.productTypeId == 3 ||
          b.productTypeId == 10 ||
          b.productTypeId == 11 ||
          b.productTypeId == 12 ||
          b.productTypeId == 13 ||
          b.productTypeId == 17),
    )
    this.view = myobjects

    return
  }
  /*
  ***********
  Based off User View
  ***********
  */
  onRonView(v: any) {
    if (v === 'basic') {
      this.view = this.reload
      return
    }
    const myobjects = this.listItems.filter(
      (b) =>
        (b.productTypeId == 3 ||
          b.productTypeId == 10 ||
          b.productTypeId == 11 ||
          b.productTypeId == 12 ||
          b.productTypeId == 17) &&
        b.statusTypeId > 0 &&
        b.statusTypeId != 11 &&
        b.statusTypeId != 12,
    )
    this.view = myobjects
    this.viewlist =
      '((b.productTypeId == 3 || b.productTypeId == 10 || b.productTypeId == 11 || b.productTypeId == 12 || b.productTypeId == 17) && (b.statusTypeId > 0 && b.statusTypeId != 11 && b.statusTypeId != 12))'
  //  this.cook.set('_viewsPending', this.viewlist.replace(/\s/g, ''), 2)
    localStorage.setItem('_viewsPending', this.viewlist) // .replace(/\s/g, "")
    sessionStorage.removeItem('blotterIdFiltered')
    return
  }
  /*
  ***********
  Based off User View
  ***********
  */
  onInsView(v: any) {
    if (v === 'basic') {
      this.view = this.reload
      return
    }
    const myobjects = this.listItems.filter(
      (b) =>
        ((b.productTypeId == 5 ||
          b.productTypeId == 6 ||
          b.productTypeId == 7 ||
          b.productTypeId == 8 ||
          b.productTypeId == 9 ||
          b.productTypeId == 14 ||
          b.productTypeId == 16) &&
          b.statusTypeId == 1) ||
        ((b.productTypeId == 2 ||
          b.productTypeId == 4 ||
          b.productTypeId == 5 ||
          b.productTypeId == 16) &&
          b.statusTypeId == 5) ||
        ((b.productTypeId == 2 ||
          b.productTypeId == 4 ||
          b.productTypeId == 5 ||
          b.productTypeId == 16) &&
          b.statusTypeId == 1 &&
          b.transactionTypeDesc != 'New account Purchase' &&
          b.transactionTypeDesc != 'Additional Purchase'),
    )
    this.view = myobjects
    //  sessionStorage.removeItem('blotterIdFiltered')
    return
  }

  /*
  ***********
  Based off User View
  ***********
  */
  onPrliminaryView(v: any) {
    if (v === 'basic') {
      this.view = this.reload
      return
    }
    const myobjects = this.listItems.filter(
      (b) =>
        (b.statusTypeId == 1 &&
          b.transactionTypeDesc === 'New Account Purchase' &&
          (b.productTypeId == 2 || b.productTypeId == 4)) ||
        b.statusTypeId == 8 ||
        ((b.productTypeId == 2 || b.productTypeId == 4) &&
          b.transactionTypeDesc === 'Additional Purchase' &&
          b.statusTypeId == 1),
    )
    this.view = myobjects

    return
  }
  /*
  ***********
  Based off User View
  ***********
  */
  FilterbyblotterId(v: any) {
    if (v === 'basic') {
      this.view = this.reload
      return
    }
  }
  onDocumentReviewView(v: any) {
    if (v === 'basic') {
      this.view = this.reload
      return
    }
    const myobjects = this.listItems.filter(
      (b) =>
        (b.productTypeId == 2 ||
          b.productTypeId == 4 ||
          b.productTypeId == 5 ||
          b.productTypeId == 6 ||
          b.productTypeId == 7 ||
          b.productTypeId == 8 ||
          b.productTypeId == 9 ||
          b.productTypeId == 14 ||
          b.productTypeId == 16) &&
        b.statusTypeId == 0,
    )
    this.view = myobjects

    return
  }
  /*
  ***********
  Based off User View
  ***********
  */
  onJerolynView(v: any) {
    if (v === 'basic') {
      this.view = this.reload
      return
    }
    const myobjects = this.listItems.filter(
      (b) =>
        (b.productTypeId == 1 || b.productTypeId == 13) &&
        b.statusTypeId > 0 &&
        b.statusTypeId !== 11 &&
        b.statusTypeId !== 12,
    )
    this.view = myobjects
    return
  }
  /*
  ***********
  Close File Manager
  ***********
  */
  onDialogClose() {
    this.opened = false
    this.openup = false
  }
  /*
  ***********
  Account Reciept Close Popup.
  ***********
  */
  onDialogReciptClose() {
    this.openAccountReadOnly = false
  }
  close(): void {
    this.opened = false
    this.openup = false
    const param = {
      Blotterid: this.blotterId.toString(),
      user: localStorage.getItem('usr'),
    }
    /* this.ur.checkfiles(param).subscribe((r) => {
      if (this.blotterId.toString().length > 0) {
        this.myblot = r[0].alertRep
      } else {
        this.myblot = false
      }
      if (this.myblot === false) {
        if (r.length > 0) {
          Object.keys(r).forEach((key) => {
            r[key]
          })
          for (const key in r) {
            if (Object.prototype.hasOwnProperty.call(r, key)) {
              const value = r[key].emailRecordId
              const params = { emailRecordId: value }
              if (value !== 0) {
                this.ur.RemoveEmailRecordupload(params).subscribe({})
              }
            }
          }
        }
      }
    }) */
  }
  /*
  ***********
  File Manager
  ***********
  */
  viewFiles(
    repId: string,
    clientName: string,
    blotterId: string,
    clientId: string,
    outquerystr: string,
  ): void {
    // If windowRef is not null, close the window before opening a new one
    if (this.windowRef) {
      this.windowRef.close()
    }

    this.outquerystring = outquerystr
    this.clientId = clientId
    this.clientName = clientName
    this.repId = repId
    this.blotterId = blotterId
    if (clientName.length > 0) {
      this.clientName = clientName
    }

    this.windowRef = this.windowService.open({
      title: 'File Manager',
      content: FilemanagerComponent,
      width: 1000,
      height: 675,
    })

    const fileManager = this.windowRef.content.instance

    fileManager.outputClientId = this.clientId
    fileManager.outputrepId = this.repId
    fileManager.clientName = this.clientName
    fileManager.outquery = this.outquerystring
    fileManager.viewallblot = this.viewallblot
    fileManager.blotterId = this.blotterId

    // Sets windowRef to null when window is closed
    this.windowRef.result.subscribe((result) => {
      if (result instanceof WindowCloseResult) {
        this.windowRef = null
      }
    })
  }
  /*
  ***********
  BookMark from Grid
  ***********
  */
  bookMarks(blotterId: number) {
    const param = { blotterId: blotterId }
    this.ur.PostBookMarks(param).subscribe(() => {
      const duration = 1500
      this.showToastpst('success', 'Book Mark was added')
      this.GetPendingTransaction()
    })
  }
  showToastpst(status: 'success' | 'error' | 'info' | 'warning', message: string) {
    switch (status) {
      case 'success':
        this.toastrService.success(message, 'Success');
        break;
      case 'error':
        this.toastrService.error(message, 'Error');
        break;
      case 'info':
        this.toastrService.info(message, 'Info');
        break;
      case 'warning':
        this.toastrService.warning(message, 'Warning');
        break;
      default:
        this.toastrService.show(message);
        break;
    }
  }
 showToast(status: 'success' | 'error' | 'info' | 'warning', message: string) {
    switch (status) {
      case 'success':
        this.toastrService.success(message, 'Success');
        break;
      case 'error':
        this.toastrService.error(message, 'Error');
        break;
      case 'info':
        this.toastrService.info(message, 'Info');
        break;
      case 'warning':
        this.toastrService.warning(message, 'Warning');
        break;
      default:
        this.toastrService.show(message);
        break;
    }
  }

  /*
***********
BookMark Remove from Grid
***********
*/
  bookMarksremoved(bookmarkId: number) {
    const param = { bookmarkId }
    this.ur.PostBookMarksRemove(param).subscribe(() => {
      const duration = 1500
      this.showToastpst('success', 'Book Mark was removed')
      this.GetPendingTransaction()
    })
  }
  public onStateChange(states): void {
    this.enlarge = states
  }
  /*
  ***********
  pass Param @BlotterId
  Query String Encrypted Param Value
  ***********
  */
  ReviewUpdateAccountForm(blotID: number) {
    const param = CryptoJS.AES.encrypt(
      encodeURI(blotID.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    this.router.navigate(['/pages/TabsScreen/tab-views'], {
      queryParams: { Rview: param },
    })

    // Product Type  Trans type
  }
  /*
  ***********
  pass Param @BlotterId
  pass Param @clId // ClientId
  pass Param @repId // RepId
  pass Param @statusTypeId // status
  pass Param @transactionId // transactiontypeId
  pass Param @productTypeId // Product Type
  Query String Encrypted Param Value
  Edit Transaction Form.
  ***********
  */
  EditTransactions(
    blotID: number,
    clientId: number,
    repId: number,
    clt: string,
    statustype: number,
    tranactionstype: number,
    producttype: number,
    reviewtransaction: boolean,
    accountformreview: boolean,
    stateid: string,
  ) {
    const blotterIdEncrypted = this.encryptProperty(blotID.toString())
    const clientIdEncrypted = this.encryptProperty(clientId.toString())
    const repIdEncrypted = this.encryptProperty(repId.toString())
    const clientNameEncrypted = this.encryptProperty(clt)
    const statusTypeIdEncrypted = this.encryptProperty(statustype.toString())
    const transactionTypeIdEncrypted = this.encryptProperty(
      tranactionstype.toString(),
    )
    const productTypeIdEncrypted = this.encryptProperty(producttype.toString())
    const stateIdEncrypted = this.encryptProperty(stateid)
    if (tranactionstype === 5) {
      this.EditAccount(
        clientId,
        blotterIdEncrypted,
        clientIdEncrypted,
        repIdEncrypted,
        clientNameEncrypted,
        statusTypeIdEncrypted,
        transactionTypeIdEncrypted,
        productTypeIdEncrypted,
        reviewtransaction,
        accountformreview,
        stateIdEncrypted,
        repId,
      )
      return
    }
    this.router.navigate(['/pages/TabsScreen/tab-views'], {
      queryParams: {
        Rview: blotterIdEncrypted,
        clientId: clientIdEncrypted,
        rId: repIdEncrypted,
        cl: clientNameEncrypted,
        EditTrans: true,
        statustype: statusTypeIdEncrypted,
        transaction: transactionTypeIdEncrypted,
        product: productTypeIdEncrypted,
        reviewtrans: reviewtransaction,
        accountformrvew: accountformreview,
        edittransactionShow: true,
        stateId: stateIdEncrypted,
        rIdunencrypt: repId,
      },
    })
    return
  }
  /*
***********
pass Param @transactionId // transactiontypeId
Edit Transaction Form.
***********
*/
  EditAccount(
    clientId: number,
    param,
    paramcli,
    paramrepencode,
    paramclientname,
    paramstatustype,
    paramtransactiontype,
    paramproducttype,
    reviewtransaction,
    accountformreview,
    paramstatetype,
    repIdunencrypt,
  ) {
    this.router.navigate(['/pages/TabsScreen/tab-views'], {
      queryParams: {
        Rview: param,
        Cld: clientId,
        clientId: paramcli,
        rId: paramrepencode,
        cl: paramclientname,
        EditTrans: true,
        statustype: paramstatustype,
        transaction: paramtransactiontype,
        product: paramproducttype,
        reviewtrans: reviewtransaction,
        accountformrvew: accountformreview,
        edittransactionShow: true,
        stateId: paramstatetype,
        repunencrypt: repIdunencrypt,
      },
    })
  }
  /*
  ***********
  pass Param @BlotterId
  pass Param @clId // ClientId
  pass Param @repId // RepId
  Query String Encrypted Param Value
  Edit Transaction Form.
  ***********
  */
  ReviewAccountTransactionsview(
    blotID: number,
    clId: number,
    repId: number,
    clt: string,
    statustype: number,
    tranactionstype: number,
    producttype: number,
    reviewtransaction: boolean,
    accountformreview: boolean,
  ) {
    const param = CryptoJS.AES.encrypt(
      encodeURI(blotID.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramcli = CryptoJS.AES.encrypt(
      encodeURI(clId.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramrepencode = CryptoJS.AES.encrypt(
      encodeURI(repId.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramclientname = CryptoJS.AES.encrypt(
      encodeURI(clt.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramstatustype = CryptoJS.AES.encrypt(
      encodeURI(statustype.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramtransactiontype = CryptoJS.AES.encrypt(
      encodeURI(tranactionstype.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramproducttype = CryptoJS.AES.encrypt(
      encodeURI(producttype.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    this.router.navigate(['/pages/TabsScreen/tab-views'], {
      queryParams: {
        Rview: param,
        cld: paramcli,
        rId: paramrepencode,
        cl: paramclientname,
        ReviewShow: true,
        statustype: paramstatustype,
        transaction: paramtransactiontype,
        product: paramproducttype,
        paramAccReview: 'Accountreview',
        reviewtrans: reviewtransaction,
        accountformrvew: accountformreview,
        accountformShow: true,
      },
    })

    // Product Type  Trans type
  }
  /*
 ***********
 pass Param @BlotterId
 pass Param @clId // ClientId
 pass Param @repId // RepId
 Query String Encrypted Param Value
 Edit Transaction Form.
 ***********
 */
  ReviewTransactionsview(
    blotID: number,
    clId: number,
    repId: number,
    clt: string,
    statustype: number,
    tranactionstype: number,
    producttype: number,
    reviewtransaction: boolean,
    accountformreview: boolean,
  ) {
    const param = CryptoJS.AES.encrypt(
      encodeURI(blotID.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramcli = CryptoJS.AES.encrypt(
      encodeURI(clId.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramrepencode = CryptoJS.AES.encrypt(
      encodeURI(repId.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramclientname = CryptoJS.AES.encrypt(
      encodeURI(clt.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramstatustype = CryptoJS.AES.encrypt(
      encodeURI(statustype.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramtransactiontype = CryptoJS.AES.encrypt(
      encodeURI(tranactionstype.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramproducttype = CryptoJS.AES.encrypt(
      encodeURI(producttype.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    this.router.navigate(['/pages/TabsScreen/tab-views'], {
      queryParams: {
        RviewAccount: param,
        clientId: paramcli,
        rId: paramrepencode,
        cl: paramclientname,
        ReviewShow: true,
        statustype: paramstatustype,
        transaction: paramtransactiontype,
        product: paramproducttype,
        paramAccReview: 'Transaction',
        reviewtrans: reviewtransaction,
        accountformrvew: accountformreview,
        reviewtransShow: true,
      },
    })

    // Product Type  Trans type
  }
  /*  this.router.navigate(['/pages/layout/tabs'], {
     queryParams: { Cld: blotID }
   });
   });
 } */
  /*
  ***********
  pass Param @BlotterId
  opens File Manager
  ***********
  */
  ViewPopupTransactions(blotID: number) {
    this.onDialogClose()
    this.blotId = blotID
    this.openup = true
  }

  openForm(data: any) {
    this.RepNamInfo = data
    this.blotterComment = Number(data.blotterId)
    this.openAccountReadOnly = true
  }
  private encryptProperty(property: string): string {
    return CryptoJS.AES.encrypt(
      encodeURI(property).trim(),
      environment.securepw.trim(),
    ).toString()
  }
}
